export default __webpack_public_path__ + "static/spacing-tokens-light-08cedb1f737b7a6b14ba1af63b715cf349820dd93b064060062e08842f85fc01.png";